import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center bg-navy overflow-hidden">
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v60H0z' fill='none' stroke='white' stroke-width='0.5'/%3E%3C/svg%3E")`,
          backgroundSize: '60px 60px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-24 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="text-sm text-gray-400">
              <Link to="/" className="hover:text-secondary transition-colors">Home</Link>
              <span className="mx-2">/</span>
              <span className="text-white">Services</span>
            </div>

            <div className="space-y-4">
              <h1 className="text-6xl font-bold text-white">
                Comprehensive
              </h1>
              <h2 className="text-5xl font-serif italic bg-gradient-to-r from-secondary to-primary bg-clip-text text-transparent">
                Marketing Solutions
              </h2>
            </div>

            <p className="text-lg text-gray-300 leading-relaxed max-w-xl">
              We deliver end-to-end digital marketing services designed to elevate your brand, engage your audience, and drive sustainable business growth through innovative strategies and proven methodologies.
            </p>
          </div>

          {/* Right 3D Element */}
          <div className="relative h-96 flex items-center justify-center">
            <div className="relative w-full h-full">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-80 h-80 bg-gradient-to-br from-secondary/20 to-primary/20 rounded-full blur-3xl animate-pulse"></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center animate-spin" style={{ animationDuration: '30s' }}>
                <div className="w-72 h-72 border-2 border-secondary/30 rounded-3xl transform rotate-45"></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center animate-spin" style={{ animationDuration: '20s', animationDirection: 'reverse' }}>
                <div className="w-56 h-56 border-2 border-primary/30 rounded-3xl transform rotate-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesHero;
